import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const buttonThemeToken: any = {
  paddingInline: "24px",
  paddingInlineLG: "24px",
  paddingInlineSM: "16px",
  controlHeight: "40px",
  controlHeightLG: "48px",
  controlHeightSM: "32px",

  //===================== FONT ================================//
  contentFontSize: variableTypography["BodyH200FontSize"],
  contentFontSizeLG: variableTypography["BodyH300FontSize"],
  contentFontSizeSM: variableTypography["BodyH100FontSize"],
  contentFontWeight: variableTypography["BodyH200FontWeight"],
  contentFontWeightLG: variableTypography["BodyH300FontWeight"],
  contentFontWeightSM: variableTypography["BodyH100FontWeight"],
  contentLineHeight: variableTypography["BodyH200LineHeight"],
  contentLineHeightLG: variableTypography["BodyH300LineHeight"],
  contentLineHeightSM: variableTypography["BodyH100LineHeight"],
  fontFamily: variableTypography["BodyMediumFontFamily"],

  //===================== ICON ================================//
  onlyIconSize: variableTypography["BodyH400FontSize"],
  onlyIconSizeLG: variableTypography["BodyH500FontSize"],
  onlyIconSizeSM: variableTypography["BodyH300FontSize"],

  //===================== DISABLED ================================//
  borderColorDisabled: variableColors["ColorFigmaNeutralGrayscaleGray30"],
  colorTextDisabled: variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],
  colorBgContainerDisabled: variableColors["ColorFigmaNeutralGrayscaleGray30"],

  //===================== DEFAULT ================================//
  defaultBorderColor: variableColors["ColorFigmaComplementaryBlue50"],
  defaultColor: variableColors["ColorFigmaComplementaryBlue50"],
  defaultBg: variableColors["ColorFigmaNeutralWhiteWhite100"],
  defaultHoverBg: variableColors["ColorFigmaNeutralWhiteWhite100"],
  defaultHoverBorderColor: variableColors["ColorFigmaComplementaryBlue50"],
  defaultHoverColor: variableColors["ColorFigmaComplementaryBlue50"],
  defaultActiveColor: variableColors["ColorFigmaComplementaryBlue50"],
  defaultActiveBorderColor: variableColors["ColorFigmaComplementaryBlue50"],
  defaultShadow: "none",

  //===================== PRIMARY ================================//
  primaryShadow: "none",

  //===================== DANGER ================================//
  dangerShadow: "none",
};
